import { ButtonBase, Typography } from "@mui/material";
import { ReactComponent as AddIcon } from "Components/_Shared/Icons/Assets/add.svg";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import type { FC } from "react";

const ICON_SIZE = 24;
const DEFAULT_MIN_HEIGHT = 130;

type Props = {
  readonly title: string;
  readonly subtitle?: string;
  /** Matches the height of a single item, so the tile doesn't look squashed when it's alone in its row. */
  readonly minHeight?: number;
  readonly disabled?: boolean;
  readonly onClick: () => void;
};

export const FormDrawerAddTile: FC<Props> = ({ title, subtitle, minHeight = DEFAULT_MIN_HEIGHT, disabled = false, onClick }) => (
  <ButtonBase
    disabled={disabled}
    onClick={onClick}
    sx={(theme) => ({
      flexDirection: "column",
      gap: Spacing.S,
      alignSelf: "stretch",
      minHeight,
      p: Spacing.L,
      border: "1px dashed",
      borderColor: "grey.400",
      borderRadius: Radius.L,
      color: disabled ? "text.disabled" : "primary.main",
      transition: "border-color 150ms",
      "&:hover": { borderColor: "primary.main" },
      "&.Mui-focusVisible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
    })}
  >
    <AddIcon width={ICON_SIZE} height={ICON_SIZE} />

    <Typography variant="body2" fontWeight={700} color="inherit">
      {title}
    </Typography>

    {subtitle && (
      <Typography variant="caption" color="text.secondary">
        {subtitle}
      </Typography>
    )}
  </ButtonBase>
);
